/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Bank Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  ListAssociatedPaymentAccountsParams,
  UKVerifiedPaymentAccountResponse,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const listAssociatedPaymentAccounts = (
  params?: ListAssociatedPaymentAccountsParams,
  signal?: AbortSignal
) => {
  return customInstance<UKVerifiedPaymentAccountResponse[]>({
    url: `/banks/accounts/payment`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListAssociatedPaymentAccountsQueryKey = (
  params?: ListAssociatedPaymentAccountsParams
) => {
  return [`/banks/accounts/payment`, ...(params ? [params] : [])] as const;
};

export const getListAssociatedPaymentAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>,
  TError = unknown
>(
  params?: ListAssociatedPaymentAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAssociatedPaymentAccountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>
  > = ({ signal }) => listAssociatedPaymentAccounts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAssociatedPaymentAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>
>;
export type ListAssociatedPaymentAccountsQueryError = unknown;

export const useListAssociatedPaymentAccounts = <
  TData = Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>,
  TError = unknown
>(
  params?: ListAssociatedPaymentAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssociatedPaymentAccounts>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAssociatedPaymentAccountsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
